import {routes} from '../../../../../../config/routes';
import {getFinalizeOrderRedirectPath} from '../../../../../utils/getFinalizeOrderRedirectPath';
import {getLanguagePath} from '../../../../../utils/language';

export const getReferralCode = (search: string) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get('referralCode');
};

export function getSuccessRedirectPath(search: string, pathname: string) {
  const languagePath = getLanguagePath(pathname);
  const referralCode = getReferralCode(search);

  if (referralCode) {
    return `${languagePath}/?referral=${referralCode}`;
  }

  return (
    getFinalizeOrderRedirectPath(search, pathname) ??
    `${languagePath}${routes.PERSONAL_AREA_PATH}`
  );
}
